<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'DASHBOARD.TITLE' | translate}}</h2>
    <ntr-add-button [openView]="'dashboard/add'"></ntr-add-button>

    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'dashboard'" [modelView]="'dashboard'" [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['','Name','Type']" (onDeleteQuery)="deleteDashboard($event)"></ntr-datatable>
</div>